import { LogoMark } from "./Logo";
import { waLink } from "@/lib/whatsapp";

export const Footer = () => {
    const year = new Date().getFullYear();
    return (
        <footer data-testid="main-footer" className="border-t border-white/[0.06] bg-[#0D121F]/60">
            <div className="mx-auto max-w-7xl px-5 py-14 sm:px-8">
                <div className="flex flex-col items-start justify-between gap-10 md:flex-row md:items-center">
                    <div className="flex items-center gap-3">
                        <LogoMark size={40} />
                        <div>
                            <p className="text-lg font-extrabold tracking-tight text-slate-50">
                                Strondex<span className="text-cyan-400"> Tech</span>
                            </p>
                            <p className="mt-0.5 text-xs text-slate-500">
                                Tecnologia · Suporte de TI · Sites · Cardápio Digital
                            </p>
                        </div>
                    </div>
                    <nav className="flex flex-wrap gap-x-8 gap-y-3" aria-label="Links do rodapé">
                        <a href="#servicos" data-testid="footer-link-servicos" className="text-sm text-slate-400 transition-colors hover:text-cyan-300">Serviços</a>
                        <a href="#cardapio" data-testid="footer-link-cardapio" className="text-sm text-slate-400 transition-colors hover:text-cyan-300">Cardápio Digital</a>
                        <a href="#sobre" data-testid="footer-link-sobre" className="text-sm text-slate-400 transition-colors hover:text-cyan-300">Sobre</a>
                        <a href={waLink("general")} target="_blank" rel="noopener noreferrer" data-testid="footer-link-whatsapp" className="text-sm font-semibold text-[#25D366] transition-colors hover:text-[#2ce06f]">WhatsApp</a>
                    </nav>
                </div>
                <div className="mt-10 border-t border-white/[0.06] pt-8">
                    <p data-testid="footer-copyright" className="text-sm text-slate-500">
                        © {year} Strondex Tech. Todos os direitos reservados.
                    </p>
                    <p className="mt-2 text-sm text-slate-600">
                        Atendimento especializado no Campo Limpo, Taboão da Serra e Zona
                        Sul de São Paulo — SP.
                    </p>
                    <p className="mt-2 text-xs text-slate-600">
                        Desenvolvido com excelência técnica por graduado em Análise e
                        Desenvolvimento de Sistemas (TADS).
                    </p>
                </div>
            </div>
        </footer>
    );
};
